/**
 * Enumerates the main categories of companies supported by the platform.
 */
export enum CompanyTypeEnum {
  /** Standard hotel operation. */
  hotel = 'hotel',

  /** Apartment style accommodation. */
  apartments = 'apartments',

  /** Company intranet instance used internally. */
  companyIntranet = 'companyIntranet',

  /** Marketplace or shopping mall implementation. */
  smartMall = 'smartMall',

  /** Administration for local smart area or municipality. */
  smartAreaAdministration = 'smartAreaAdministration',
}
